import {Component, OnDestroy, OnInit} from '@angular/core';
import {MachineMaintenanceService} from '../../../services/machine.maintenance.service';
import {Subject} from 'rxjs/Subject';
import {MachineMaintenance} from '../../../models/machine.maintenance.model';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication.service';

@Component({
  providers: [MachineMaintenanceService],
  selector: 'app-machine-maintenance-details',
  templateUrl: './machine.maintenance.details.component.html',
})
export class MachineMaintenanceDetailsComponent implements OnDestroy, OnInit {
  public maintenance: MachineMaintenance;

  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _machineMaintenanceService: MachineMaintenanceService,
              private _authService: AuthenticationService) {

  }

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const maintenanceId = params['id'];

        if (maintenanceId) {
          this._machineMaintenanceService.load(maintenanceId);
          this._machineMaintenanceService.maintenances$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              maintenances => {
                this.maintenance = maintenances.find(pr => pr._id === maintenanceId);
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public isAdmin(): boolean {
    if (this._authService.user && this._authService.user.role === 'admin') {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/machinemaintenance/details/machine.maintenance.details.component.ts